function getDisabledAttribute(disabled) {
  return {
    /**
     * NOTE:
     * disabled 속성을 div element가 가지고 있지 않고,
     * button element와 조합하여 사용할 때, 조합 요소를 비활성화하기 위해 함수를 통해 부여합니다.
     */
    ["disabled"]: disabled,
    ["aria-disabled"]: disabled,
    ...disabled === true && { ["data-disabled"]: "" }
  };
}

export { getDisabledAttribute };
//# sourceMappingURL=attribute.mjs.map
